import { render, staticRenderFns } from "./consumptionManagement.vue?vue&type=template&id=1013b7f4&scoped=true&"
import script from "./consumptionManagement.vue?vue&type=script&lang=js&"
export * from "./consumptionManagement.vue?vue&type=script&lang=js&"
import style0 from "./consumptionManagement.vue?vue&type=style&index=0&id=1013b7f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013b7f4",
  null
  
)

export default component.exports